import { todayCounts, type TodayProgress } from "./progress.ts";

/** The day in three counts (taken, to take, later), on Home and on the Day view. A zero is left out. */
export function TodayChips({ progress }: { progress: readonly TodayProgress[] }) {
  const counts = todayCounts(progress);
  const chips = [
    { text: `${counts.taken} taken`, n: counts.taken, className: "bg-confirmed-surface text-confirmed-ink" },
    { text: `${counts.toTake} to take`, n: counts.toTake, className: "bg-late-surface text-late-ink" },
    { text: `${counts.later} later`, n: counts.later, className: "bg-sunken text-ink-2" },
  ].filter((chip) => chip.n > 0);
  return (
    <>
      {chips.map((chip) => (
        <span key={chip.text} className={`rounded-full px-2.5 py-0.5 text-[12.5px] font-semibold ${chip.className}`}>
          {chip.text}
        </span>
      ))}
    </>
  );
}
